// removed by extract-text-webpack-plugin
module.exports = {"dialog":"_2IOvbFpgmZq-vIQhtpWvZI","dialog-title":"_23d7-nDRMGppQkOVjVr1c6","dialog-message":"_2v3XAeUw7yAwdYYvLdrbm8","btns":"_2P0IWfGcx9_EFNtfLKTKuS","btn":"_1Oc1zx3lq-28mfEmqrqbRX"};


//////////////////
// WEBPACK FOOTER
// ./src/v2SPRINTA/molecules/Dialog/style.module.css
// module id = 465
// module chunks = 39